import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconsService {
  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    const domain = isPlatformServer(platformId) ? 'http://localhost:4000/' : '';
    iconRegistry.addSvgIcon(
      'inv-verified',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/logo-inviertis.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'flujo-caja',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/flujo-caja.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'moneda',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/moneda.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'retorno-total',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/retorno-total.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'valor-patrimonio',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/valor-patrimonio.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'inviertis-go',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/fichero-port.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'new-search',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/new-search.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'new-search-fill',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/new-search-fill.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'heart-fill',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/heart-fill.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'operations',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/operations.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'operations-fill',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/operations-fill.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'search',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/search.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'search-fill',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/search-fill.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'inmueble',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/inmueble.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'inmueble-fill',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/inmueble-fill.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'portfolio',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/portfolio.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'portfolio-fill',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/portfolio-fill.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'sale',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/sale.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'sale-fill',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/sale-fill.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'myAccount',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/myAccount.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'bell',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/bell.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'logOut',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/logOut.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'back-icon',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/arrow-prev.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'phone-icon',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/phone-icon.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'plus-box-icon',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/plus-icon.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'firma',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/icons/sign-icon-blue.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'user',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/img/servicios/user-icon.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'certificate',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/img/servicios/certificate-icon.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'emails',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/img/servicios/emails-icon.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'calendar',
      sanitizer.bypassSecurityTrustResourceUrl(
        domain + 'assets/img/servicios/calendar-icon.svg'
      )
    );
  }
}
